import { useMemo } from "react";
import { Dropdown } from "@/components/Dropdown/Dropdown";
import { resumeFontSizes, resumeHeadingFontSizes } from "@/constants/resume";

const getFontItems = (isHeading?: boolean) => {
    const fontSizes = isHeading ? resumeHeadingFontSizes : resumeFontSizes;
    return fontSizes.map(({ value, displayName, pxValue }) => ({
        id: value,
        title: displayName,
        style: { fontSize: `${pxValue}px` },
    }));
};

interface FontSizeSelectorProps {
    onSizeChange: (size: string) => void;
    size: string;
    isHeading?: boolean;
}

export const FontSizeSelector = ({
    onSizeChange,
    size,
    isHeading,
}: FontSizeSelectorProps) => {
    const fonts = useMemo(() => getFontItems(isHeading), [isHeading]);
    const activeItem = fonts.find(item => item.id === size);

    return (
        <Dropdown
            items={fonts}
            activeId={size}
            handleChange={(id: string) => onSizeChange(id)}
            title={activeItem?.title}
            style={activeItem?.style}
        />
    );
};
